import { Theme } from "@mui/material/styles";
import { alpha, SystemStyleObject } from "@mui/system";

const featuresModalStyles = {
  modalRoot: (): SystemStyleObject<Theme> => ({
    zIndex: 99999,
  }),
  modal: (): SystemStyleObject<Theme> => ({
    overflow: "hidden",
    borderRadius: 0,
    m: 0,
    height: "100%",
    width: "100%",
    maxHeight: "none",
    maxWidth: "none",
  }),
  wrapper: (theme: Theme): SystemStyleObject<Theme> => ({
    height: "100%",
    width: "100%",
    overflow: "auto",
    backgroundColor: theme.palette.primary.dark,

    "&::before": {
      content: "''",
      position: "absolute",
      left: 0,
      right: 0,
      height: "100%",
      width: "auto",

      backgroundImage: `linear-gradient(90deg, ${alpha(
        theme.palette.primary.dark,
        0.9,
      )} 50%, transparent), url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL
        }/pages/nfcTagsPage/features/modal-background.svg)`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right center",
      backgroundSize: "auto 100%",
      pointerEvents: "none",
    },
  }),
  container: (): SystemStyleObject<Theme> => ({
    height: "100%",
    position: "relative",
    zIndex: 10,
    py: { xs: 6, lg: 10 },
  }),
  closeButton: (): SystemStyleObject<Theme> => ({
    width: "max-content",
    mb: { xs: 3, lg: 6 },
    p: 0,
  }),
  arrow: (theme: Theme): SystemStyleObject<Theme> => ({
    color: theme.palette.text.secondary,
  }),
  title: (theme: Theme): SystemStyleObject<Theme> => ({
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    mb: { xs: 2, md: 4 },
    fontWeight: 600,
  }),
  details: (theme: Theme): SystemStyleObject<Theme> => ({
    color: theme.palette.text.secondary,
    fontWeight: 400,
    lineHeight: 1.4,
    width: { xs: "100%", sm: "70%" },
  }),
  imageWrapper: (): SystemStyleObject<Theme> => ({
    display: { xs: "none", sm: "flex" },
    alignItems: "center",
    justifyContent: "center",
    width: "40%",
  }),
};

export default featuresModalStyles;
